import { Link } from "react-router-dom"
import { ArticlesFilteredsTypes } from "../../../models/news-articles/articles-filtered-model"

type NewsAndArticleCardTypes = {
  cardSecTitle: string
  cardSecSubTitle: string
  cardSecContent: string
  cardSecInfo: string
  article: ArticlesFilteredsTypes[]
}

const DepartmentsSliderCard404 = (props: NewsAndArticleCardTypes) => {

  const ArticlesFilteredsData404 = props.article

  return <div className={`feature-single ${props.cardSecTitle}`}>
    <Link to='/news-and-articles/news-articles?category=404'>
      <div className={props.cardSecSubTitle}>This Week at FDA</div>
    </Link>
    <Link to={ArticlesFilteredsData404[0]?.articlesList[0]?.articleUrl}>
      <img src={ArticlesFilteredsData404[0]?.articlesList[0]?.articleTeaserImage} alt={ArticlesFilteredsData404[0]?.articlesList[0]?.articleName} loading="lazy" />
    </Link>
    <div className={props.cardSecContent}>
      <div className={props.cardSecInfo} >
        <ul>
          {(ArticlesFilteredsData404[0]?.articlesList?.length > 1) ? (
            <>
              {ArticlesFilteredsData404[0]?.articlesList.map((item, index) => {
                  return <li key={index}>
                    <Link to={item.articleUrl} dangerouslySetInnerHTML={{ __html: item.articleName }}></Link>
                  </li>
                })}
              <li>
                {(ArticlesFilteredsData404[0]?.articlesList.length > 1) && <Link to='/news-and-articles/news-articles?category=404' className="view-more">See more</Link>}
              </li>
            </>
          ) : (
            <li>
              <Link to={ArticlesFilteredsData404[0]?.articlesList[0].articleUrl} dangerouslySetInnerHTML={{ __html: ArticlesFilteredsData404[0]?.articlesList[0]?.articleName }}></Link>
              <p dangerouslySetInnerHTML={{ __html: ArticlesFilteredsData404[0]?.articlesList[0]?.articleTeaserText }}></p>
            </li>
          )}
        </ul>
      </div>
    </div>
  </div>
}

export default DepartmentsSliderCard404
